/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// deno-lint-ignore-file

import Axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';

// OVERWRITTEN - added customErrorHandling param
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  customErrorHandling?: boolean | ((response: AxiosResponse) => boolean);
}

export const axios = Axios.create({
  baseURL: '/reports',
  // OVERWRITTEN - added custom params serializer
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});
export const childProtectionClient = {
  /**
   * @param filter     */
  getChildProtectionReportTableData(
    filter: ChildProtectionReportFilter,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<PagedTableReportViewModel> {
    let url = '/api/child-protection/report';

    return axios.request<PagedTableReportViewModel>({
      url: url,
      method: 'POST',
      data: filter,
      ...$config,
    });
  },
  /**
   * @param data     */
  getChildProtectionReportTableDataExcel(
    data: TableReportExportDataBase,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/child-protection/excel';

    return axios.request<any>({
      url: url,
      method: 'POST',
      data: data,
      ...$config,
    });
  },
  /**
   * @param childProtectionGetExamDatesQuery  (API name: ChildProtectionGetExamDatesQuery)   */
  getExamDates(
    childProtectionGetExamDatesQuery: IGetExamDatesFromChildProtectionServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<string[]> {
    let url = '/api/child-protection/exam-dates';

    return axios.request<string[]>({
      url: url,
      method: 'GET',
      params: {
        filterBy: serializeQueryParam(childProtectionGetExamDatesQuery.filterBy),
        examPlatform: serializeQueryParam(childProtectionGetExamDatesQuery.examPlatform),
      },
      ...$config,
    });
  },
  /**
   * @param childProtectionGetVenuesQuery  (API name: ChildProtectionGetVenuesQuery)   */
  getVenues(
    childProtectionGetVenuesQuery: IGetVenuesFromChildProtectionServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<VenueDto[]> {
    let url = '/api/child-protection/venues';

    return axios.request<VenueDto[]>({
      url: url,
      method: 'GET',
      params: {
        filterBy: serializeQueryParam(childProtectionGetVenuesQuery.filterBy),
        examPlatform: serializeQueryParam(childProtectionGetVenuesQuery.examPlatform),
      },
      ...$config,
    });
  },
};
export const specialArrangementsClient = {
  /**
   * @param filterBy     */
  getExamDates(
    filterBy: SpecialArrangementsReportFilterBy,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<string[]> {
    let url = '/api/special-arrangements/exam-dates';

    return axios.request<string[]>({
      url: url,
      method: 'GET',
      params: {
        filterBy: serializeQueryParam(filterBy),
      },
      ...$config,
    });
  },
  /**
   * @param filter     */
  getSpecialArrangementsReportTableData(
    filter: SpecialArrangementsReportFilter,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<PagedTableReportViewModel> {
    let url = '/api/special-arrangements/report';

    return axios.request<PagedTableReportViewModel>({
      url: url,
      method: 'POST',
      data: filter,
      ...$config,
    });
  },
  /**
   * @param data     */
  getSpecialArrangementsReportTableDataExcel(
    data: TableReportExportDataBase,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/special-arrangements/excel';

    return axios.request<any>({
      url: url,
      method: 'POST',
      data: data,
      ...$config,
    });
  },
  /**
   */
  getVenues($config?: CustomAxiosRequestConfig): AxiosPromise<VenueDto[]> {
    let url = '/api/special-arrangements/venues';

    return axios.request<VenueDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const lrwSessionExamMaterialsClient = {
  /**
   * @param lrwSessionId     */
  getAttendanceRegister(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url = '/api/event-planner/lrw-sessions/{lrwSessionId}/exam-materials/attendance-register';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getDeskLabels(lrwSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<File> {
    let url = '/api/event-planner/lrw-sessions/{lrwSessionId}/exam-materials/desk-labels';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getLrwCredentials(lrwSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<File> {
    let url = '/api/event-planner/lrw-sessions/{lrwSessionId}/exam-materials/lrw-credentials';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const speakingSessionExamMaterialsClient = {
  /**
   * @param speakingSessionId     */
  getApportionmentTimetableForCandidates(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url =
      '/api/event-planner/speaking-sessions/{speakingSessionId}/exam-materials/apportionment-timetable-for-candidates';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     * @param speakingType     */
  getApportionmentTimetableForExaminers(
    speakingSessionId: number,
    speakingType: ApportionmentSpeakingType,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url =
      '/api/event-planner/speaking-sessions/{speakingSessionId}/exam-materials/apportionment-timetable-for-examiners';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      params: {
        speakingType: serializeQueryParam(speakingType),
      },
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getAttendanceRegister(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url =
      '/api/event-planner/speaking-sessions/{speakingSessionId}/exam-materials/attendance-register';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getSpeakingCredentials(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url =
      '/api/event-planner/speaking-sessions/{speakingSessionId}/exam-materials/speaking-credentials';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getSpeakingExaminersRecord(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<File> {
    let url =
      '/api/event-planner/speaking-sessions/{speakingSessionId}/exam-materials/speaking-examiners-record';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
function serializeQueryParam(obj: any) {
  // OVERWRITTEN - do not convert undefined props as string for proper API validation
  // if (obj === null || obj === undefined) return '';
  if (obj === null || obj === undefined) return undefined;
  if (obj instanceof Date) return obj.toJSON();
  if (typeof obj !== 'object' || Array.isArray(obj)) return obj;
  return Object.keys(obj)
    .reduce((a: any, b) => a.push(b + '=' + obj[b]) && a, [])
    .join('&');
}
export interface PagedTableReportViewModel extends TableReportViewModel {
  page: number;
  totalPages: number;
  totalItemsCount: number;
}

export interface TableReportViewModel {
  header?: TableReportRow[];
  data?: TableReportRow[];
  footer?: TableReportRow[];
}

export interface TableReportRow {
  columnOffset: number;
  dataCells?: TableCell[];
}

export interface TableCell {
  rowSpan: number;
  colSpan: number;
  parentIndex: number;
  isHidden: boolean;
  offset: number;
  text?: string;
  valueType?: string;
  action?: TableCellAction;
}

export interface TableCellAction {
  actionType?: string;
  actionData?: any;
}

export interface ChildProtectionReportFilter {
  districtId: number;
  product: Product;
  dates?: string[];
  timeTableSessions?: TimeTableSession[];
  venueIds?: number[];
  pageNumber?: number;
  pageSize?: number;
  filterBy?: ChildProtectionReportFilterBy[];
  lifeSkillsSessionTypes?: LifeSkillsSessionType[];
}

export enum TimeTableSession {
  AM = 1,
  PM = 2,
  Evening = 3,
  AllDay = 4,
  X = 5,
}

export enum ChildProtectionReportFilterBy {
  SpeakingExam = 0,
  LRWExam = 1,
}

export enum LifeSkillsSessionType {
  A1 = 0,
  A2 = 1,
  B1 = 2,
}

export enum Product {
  IELTS = 0,
  UKVI = 1,
  LifeSkills = 2,
}

export interface TableReportExportDataBase {
  data?: TableReportViewModel;
  filter?: RegionAndCountryBaseReportFilter;
}

export interface RegionAndCountryBaseReportFilter {
  pageNumber?: number;
  pageSize?: number;
  regionIds?: number[];
  organisationCountryIds?: number[];
  startDate?: string;
  endDate?: string;
}

export enum ExamPlatform {
  Schools = 0,
  Ukvi = 1,
  Ielts = 2,
}

export interface VenueDto {
  id: number;
  name?: string;
}

export interface SpecialArrangementsReportFilter {
  districtId: number;
  dates?: string[];
  timeTableSessions?: TimeTableSession[];
  venueIds?: number[];
  pageNumber?: number;
  pageSize?: number;
  filterBy?: SpecialArrangementsReportFilterBy[];
}

export enum SpecialArrangementsReportFilterBy {
  SpeakingExam = 0,
  LRWExam = 1,
}

export enum ApportionmentSpeakingType {
  InPerson = 1,
  RemoteSpeaking = 2,
  AvatarSpeaking = 3,
}

export interface IGetExamDatesFromChildProtectionServiceQuery {
  filterBy?: ChildProtectionReportFilterBy;
  examPlatform?: ExamPlatform;
}

export interface IGetVenuesFromChildProtectionServiceQuery {
  filterBy?: ChildProtectionReportFilterBy;
  examPlatform?: ExamPlatform;
}
